import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { of } from 'rxjs'
import { mergeMap, map } from 'rxjs/operators'
import { CCOnboardingActions, GetCCStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { CC_STATE_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import { CreditCard, CCLedger } from 'components/features/creditCard/creditCardStore/types'
import { normalize } from 'helpers/normalizeHelpers'
import { metaSelector } from 'selectors/globalSelectors'
import { saturateTransaction } from 'helpers/rawHelpers'
import { RECENT_CARD_TRANSACTIONS_LIMIT } from 'components/features/creditCard/creditCardStore/constants'


export const ccStateEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$, store, { get }) => action$.pipe(
  filterRequest(GetCCStateAction.type),
  mergeMap((action) => get(CC_STATE_URL).pipe(
    map(({ response }) => {
      const { ledgers, transactions, ...restResponse } = response

      const result = ledgers.reduce((acc, ledgerApi) => {
        const { cards: cardsApi, ...ledger } = ledgerApi
        const cards = cardsApi.map((card) => ({
          ...card,
          ledgerUid: ledger.uid,
        }))

        return {
          ledgers: [
            ...acc.ledgers,
            ledger,
          ],
          cards: [
            ...acc.cards,
            ...cards,
          ],
        }
      }, {
        ledgers: [] as CCLedger[],
        cards: [] as CreditCard[],
      })


      const meta = metaSelector(store.getState())
      const nextTransactions = transactions
        .map((transaction) => saturateTransaction(transaction, meta))
        .filter((transaction): transaction is NonNullable<typeof transaction> => !!transaction)

      return action.success({
        ...restResponse,
        cards: normalize(result.cards, 'uid'),
        ledgers: normalize(result.ledgers, 'uid'),
        transactions: normalize(nextTransactions.slice(0, RECENT_CARD_TRANSACTIONS_LIMIT), 'uid'),
      })
    }),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status }))),
  )),
)
